<!--
  a11y: outer wrapper changed to flex-col so the new close (X) button sits at
  the very top of the popup. It is FIRST in DOM with [focusInitial]=true so
  the CDK focus trap places initial focus there on open. Dismissing returns
  `undefined` from closeCard, matching Esc-key behaviour — the caller (cookie
  banner host) treats this as "user did not choose", same as a Cancel action.
-->
<div class="flex flex-col w-full gap-2" [class]="direction">
  <div class="!flex justify-end">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
      [focusInitial]="true"
      (onClick)="closeCard()" />
  </div>

  <div class="flex justify-between items-center w-full gap-4" [ngClass]="{'flex-col': isMobile}">
      <div class="flex" [ngClass]="{'flex-col items-center text-center': isMobile}">
          <img src="../../../../../assets/images/coockies.svg" alt="" aria-hidden="true" class="w-[8rem]">
          <div class="flex flex-col justify-center max-w-[37.5rem]">
              <h2 class="m-0 font-semibold text-xl">{{personalizedExperiencetext}}</h2>
              <p class="m-0 font-normal text-base">{{allowUseCookiesDescText}}</p>
          </div>
      </div>
      <div class="flex p-4 gap-4" [ngClass]="{'flex-col w-full': isMobile}">
          <mot-button [text]="agreeText" buttonClass="!bg-primary !text-white !w-full !rounded-lg !align-middle !h-[3rem]"
              (onClick)="handleClick(true)" [ngClass]="isDesktop ? '!w-[10.25rem]' : '!w-full' " />
          <mot-button [text]="dontAgreeText"
              buttonClass="!border !border-solid !border-[#B4BFCB] !w-full !rounded-lg !align-middle !h-[3rem]"
              (onClick)="handleClick(false)" [ngClass]="isDesktop ? '!w-[10.25rem]' : '!w-full' " />
      </div>
  </div>
</div>